import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/admin-console/organisation-management')({
    staticData: {
        permissions: ['admin_orgs:read'],
        breadcrumb: {
            title: 'Organisation management',
            inactive: true,
        },
        ui: {
            icon: Building2,
            title: 'Organisations',
            menuDescription: 'Manage organisations',
        },
    },
    component: Outlet,
});
